/* global globalThis */
import { useEffect } from "react";
import axiosClient from "../../api-client/AxiosClient";

export const getUserSelectedOrgConfig = async () => {
    try {
        const response = await axiosClient.get(
            "/api/Organization/GetUserSelectedOrgConfig"
        );
        return response?.data ?? null;
    } catch (error) {
        console.error("Failed to get user selected org config:", error);
        return null;
    }
};

export const setUserSelectedOrgConfig = async () => {
    try {
        const organizationConfigId = localStorage.getItem("organization_config_id");
        const selectedCorporation = localStorage.getItem("selectedCorporation");
        const organizationId = selectedCorporation
            ? JSON.parse(selectedCorporation)?.value?.toString()
            : null;

        if (!organizationConfigId || !organizationId) {
            return null;
        }

        const payload = {
            organizationConfigId: String(organizationConfigId),
            organizationId: String(organizationId),
        };

        const response = await axiosClient.post(
            "/api/Organization/SetUserSelectedOrgConfig",
            payload
        );

        return response?.data ?? null;
    } catch (error) {
        console.error("Failed to set user selected org config:", error);
        return null;
    }
};

//  fuzzy lookup to restore previous org & config on login
export const initOrgConfigFromPrevious = async () => {
    try {
        //  Get previously selected org & config
        const previousData = await getUserSelectedOrgConfig();
        const previousOrgId = previousData?.selectedOrganizationConfig?.organizationId?.trim();
        const previousConfigId = previousData?.selectedOrganizationConfig?.organizationConfigId?.trim();

        if (!previousOrgId || !previousConfigId) return null; 

        //  Get all organizations and fuzzy match by organizationId
        const orgsResponse = await axiosClient.get("/api/Organization/GetUserOrganizations");
        const orgs = Array.isArray(orgsResponse?.data) ? orgsResponse.data : [];
        const matchedOrg = orgs.find(
            (org) => String(org.organizationId) === String(previousOrgId)
        );

        if (!matchedOrg) return null;

        const selectedOrg = { label: matchedOrg.name, value: matchedOrg.organizationId };

        //  Get configs for that org and fuzzy match by organizationConfigId
        const configsResponse = await axiosClient.get(
            `/api/Organization/GetOrganizationConfigs?orgId=${matchedOrg.organizationId}`
        );
        const configs = Array.isArray(configsResponse?.data) ? configsResponse.data : [];
        const matchedConfig = configs.find(
            (cfg) => String(cfg.organizationConfigId) === String(previousConfigId)
        );

        if (!matchedConfig) return { selectedOrg, selectedConfig: null };

        const templateText = `${matchedConfig.sourceName} to ${matchedConfig.targetName}`;
        const selectedConfig = {
            label: `${matchedConfig.domainName} - ${templateText}`,
            value: matchedConfig.organizationConfigId,
            template: templateText,
            sourceName: matchedConfig.sourceName,
            targetName: matchedConfig.targetName,
        };

        return { selectedOrg, selectedConfig };
    } catch (error) {
        console.error("Failed to initialize org config from previous:", error);
        return null;
    }
};

export const useOrgConfigSync = () => {
    useEffect(() => {
        const handleStorageChange = async (e) => {
            if (
                e.detail?.key === "organization_config_id" ||
                e.detail?.key === "selectedCorporation"
            ) {
                await setUserSelectedOrgConfig();
            }
        };

        globalThis.addEventListener("customStorageChange", handleStorageChange);
        return () => {
            globalThis.removeEventListener("customStorageChange", handleStorageChange);
        };
    }, []);
};